import { FC } from 'react'
import Link from 'next/link'
import clsx from 'clsx'

import usePCWindow from 'hooks/usePCWindow'

import { IStringObj } from 'constants/types/common.types'
import { cutTxt } from 'utils/cutTxt'
import { ScreenSize } from 'constants/media-constanst'

import styles from './breadcrumb-page.module.scss'
interface IBreadcrumbsPage {
  breadData?: IStringObj[]
}

const BreadcrumbsPage: FC<IBreadcrumbsPage> = ({ breadData }) => {
  const isMobile = usePCWindow(ScreenSize.mobile)

  return (
    <div className={styles.breadcrumbs}>
      <ul className={styles.list}>
        <li className={styles.points}>
          <Link href={'/'}>Главная</Link>
        </li>
        {breadData &&
          breadData.map((item, index) => {
            const { name, link } = item

            const nameFormated = String(name)
            return (
              <Link
                className={clsx(styles.points, {
                  [styles.noSlash]: breadData.length - 1 === index,
                })}
                key={index}
                href={link}
              >
                {cutTxt(nameFormated, isMobile ? 14 : 20)}
              </Link>
            )
          })}
      </ul>
    </div>
  )
}

export default BreadcrumbsPage
